import React from 'react'
import  { 
    TitleSection, 
    BorderBottom, 
    WrappProjects,
    More,
  } from '../../globalStyle';
import Projects, { Div } from './project';
function ProjectApp(){
    return(
      <>
        {/* <Shapes polygon top/> */}
        <Div id="projects">
          <TitleSection>Projects</TitleSection>
          <BorderBottom />
          <WrappProjects>
            <Projects/>
          </WrappProjects>
          <More to='/project-all'>Projects more</More>
        </Div>
      </>
    )
  }
export default ProjectApp